import type { VoidFunctionComponent } from 'react';

import { plural } from '../../../../../../shared/helpers/plural';

import { VendoredPath } from './VendoredPath';

import styles from './VendoredPaths.module.less';

type Props = {
  dependencyTitle: string;
  vendoredPaths: string[];
};

export const VendoredPaths: VoidFunctionComponent<Props> = ({
  dependencyTitle,
  vendoredPaths,
}) => {
  const pathCount = vendoredPaths.length;
  return (
    <section>
      <div className={styles.header}>{dependencyTitle} is vendored in <b>{pathCount} {plural(pathCount, 'location')}</b></div>
      <ul className={styles.paths}>
        {vendoredPaths.map((path) => (
          <li key={path}><VendoredPath path={path} /></li>
        ))}
      </ul>
    </section>
  );
};
